// extracted by mini-css-extract-plugin
export default {"image1":"styles_image1__EvNDD","image2":"styles_image2__zHbYC","imageInColumn":"styles_imageInColumn__2Gcwg"};